/**
 * Downloads a file from a presigned URL
 * Handles both iOS and standard browser downloads
 * Based on executeDownload pattern from source modals
 */
export const downloadFile = (url: string): void => {
  if (!url) return;

  const link = document.createElement("a");
  link.href = url;
  link.style.display = "none";
  document.body.appendChild(link);

  if (/iPhone|iPad/.test(navigator.userAgent)) {
    // For iOS devices, trigger the download on click
    link.addEventListener("click", () => {
      link.setAttribute("download", url.split("/").pop() || "");
      link.click();
      document.body.removeChild(link);
    });
    link.click();
  } else {
    // For other platforms, open the PDF in a new tab
    link.target = "_blank";
    link.download = url.split("/").pop() || "";
    link.click();
    document.body.removeChild(link);
  }
};

/**
 * Downloads an in-memory Blob as a file with the given filename.
 * Useful when the file content is fetched via an authenticated request
 * and cannot be downloaded through a direct link.
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  link.style.display = "none";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
};
